import uuid from "uuid";

import dataStore from "./store";

import { createHeatMapsImages, repositionImage } from "./image-functions";

import { exludeOptions } from './exclude-option-dropdown'

const markerObject = function(
    lat,
    lng,
    slideId,
    question,
    comment,
    value,
    image
) {

    let value_type = ''

    if(question.type === 'goodbad') {

        const slide = dataStore.project.items.find( item => item.id === slideId)

        if(slide.allow_bad_options && !slide.allow_good_options){
            value_type = 'bad'
        }

        else if(!slide.allow_bad_options && slide.allow_good_options){
            value_type = 'good'
        }

    }

    return {
        lat: lat,
        lng: lng,
        item_id: slideId,
        question: question,
        comment: comment && question.type !== "scale" ? comment : "",
        value_type: value_type,
        values: value ? value : [],
        image: image ? image : { name: "", file: null },
        created: false
    };
};

const removeMarker = function(marker) {

    const index = dataStore.collectedAnswers.indexOf(marker);

    if (index > -1) {
        dataStore.collectedAnswers.splice(index, 1);
    }
};

/**
 * Description: If clicking on map or image it will hide current hint
 * @return {Void}
 */
const hideHint = function(slug, slideID) {

    let hints = JSON.parse( sessionStorage.getItem(slug + '-hints') );

    if (hints) {

        const index = hints.findIndex(obj => obj.id === slideID);

        let newObject = {
            id : slideID,
            showHint : false
        }

        if (index !== -1) {
            hints[index] = newObject;
        }

        sessionStorage.setItem(slug + '-hints', JSON.stringify(hints));

        document.querySelector(`.slide-item-${slideID} #hint`).style.display = 'none'
        
    }

    return;
};

/**
 * Description: Add answer to collection
 * @return {Void}
 */
const addAnswer = function(val) {

    dataStore.currentSlide.type === "map" || dataStore.currentSlide.type === "image" ? setFormPopUpReady() : false;

    Object.assign(val, {
        id: uuid.v4() + "-" + val.item_id + "-" + Date.now()
    });
    
    dataStore.currentOpinion = val;

    dataStore.collectedAnswers.push(val);
};

/**
 * Description: Sets form popup on images and maps ready
 * @return {Void}
 */
const setFormPopUpReady = function() {
    dataStore.formPopUpReady = true;
};

/**
 * Description: Sets form popup on images and maps ready
 * @return {Void}
 */
const setAllowToChangeFormPopUp = function() {
    dataStore.allowToChange = true;
};

/**
 * Description: Resets errors in dataStore
 * @return {Void}
 */
const resetErrors = function() {
    dataStore.errors = [];
};

/**
 * Description: Resets values in currentOpinion that are allowed
 * @return {Void}
 */
const resetCurrentOpinion = function() {

    let value;

    if( dataStore.currentSlide.question.type === "scale") {
        value = []
    } else {
        value = undefined
    }

    dataStore.currentOpinion = {
        value_type: "",
        values: value,
        comment: "",
        image: { name: "", file: null }
    };

    dataStore.allowToChange = false;
};

/**
 * Description: Gets current slide i.e one item from items in database
 * @return {Object}
 */
const getItem = function(slides, slideID) {
    return slides.filter(slide => slide.id == slideID).shift();
};

/**
 * Description: Opens information window on markers on both image and map
 * @return {Void}
 */
const toggleOpinionForm = function(marker) {

    return new Promise((resolve, reject) => {

        dataStore.activeItem = 0;

        dataStore.currentPopup = {
            id: marker.id,
            coordinates : [ parseFloat(marker.lng), parseFloat(marker.lat) ],
            custom : true
        }

        if (dataStore.addToExistingWindow) {
            dataStore.currentOpinion = marker;
            dataStore.addToExistingWindow = true;
        } 
        
        else {

            dataStore.addToExistingWindow = false;

            if (dataStore.addopinion) {
                if( Array.isArray(marker) ) {
                    marker = marker.pop()
                }
            }

            if (dataStore.justMovedPin && dataStore.addopinion) {
                dataStore.justMovedPin = false;
                return;
            }

            dataStore.feedback = false;

            let allowed = ["map", "image"];

            if (!allowed.includes(dataStore.currentSlide.type)) return;

            let oldAnswer = dataStore.collectedAnswers && dataStore.collectedAnswers.length && marker ? dataStore.collectedAnswers.filter( el => el.lat == marker.lat && el.lng == marker.lng) : undefined;

            if (Array.isArray(oldAnswer) && oldAnswer.length !== 0) {

                setFormPopUpReady();

                setAllowToChangeFormPopUp();

                if (!dataStore.addopinion) {
                    dataStore.currentOpinion = oldAnswer.filter(
                        a => !a.addOnExisting
                    );
                } else {
                    dataStore.currentOpinion = Array.isArray(oldAnswer)
                        ? oldAnswer.pop()
                        : oldAnswer;
                }

            } 
            
            else {
                resetErrors();
                resetCurrentOpinion();
            }

        }

        if (marker) {

            dataStore.infoWindowPos = {
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lng)
            };

        }

        dataStore.infoWinOpen = true;

        resolve()
    })


};

const clickOutside = function(e) {

    if( e?.mapboxEvent?.originalEvent ) {
        e = e.mapboxEvent.originalEvent 
    }

    if( e.srcElement.className.includes('image-popup') || e.srcElement.className.includes('mapboxgl-canvas') ){

        dataStore.infoWinOpen = false

        removeMarkerIfEmpty(dataStore.currentOpinion);

    }
    
};



const removeMarkerIfEmpty = function(marker) {

    let remove = false;

    // if( ! dataStore.formPopUpReady ) return

    if (Array.isArray(marker)) {
        marker = marker.pop();
    }

    if (dataStore.addToExistingWindow) {
        remove = true;
    } 
    
    else {

        // const bothGoodAndBad = dataStore.currentSlide.allow_bad_options && dataStore.currentSlide.allow_good_options

        if (marker.value_type === "" || ! marker.value_type.length) {
            remove = true;
        }
    }

    if (remove && marker) {
        dataStore.collectedAnswers.pop();
    }
};

/**
 * Description: Dont allow dropdowns on projects in list.
 * @return {Boolean}
 */
const dontAllowDropdownOptions = function(projectSlug) {
    const project = exludeOptions.find(project => project.slug === projectSlug)
    return ! ( project && dataStore.currentSlide && project.types.includes(dataStore.currentSlide.type) )
};

/**
 * Description: Allowing outputting defaults .
 * @return {Boolean}
 */
const allowedLabelsProject = function(projectSlug) {
    const project = exludeOptions.find(project => project.slug === projectSlug);
    return ( project && dataStore.currentSlide && project.types.includes(dataStore.currentSlide.type) )
};

/**
 * Description: Update answer in collection
 * @return {Boolean}
 */
const updateAnswer = function(val, id) {

    dataStore.collectedAnswers.map(v => {
        return v.id === val.id ? val : v;
    });

    const foundIndex = dataStore.collectedAnswers.findIndex(x => x.id == id);

    const item = dataStore.collectedAnswers[foundIndex]

    dataStore.collectedAnswers[foundIndex] = Object.assign(item, val);

};

const showReportArea = function(id) {

    dataStore.currentToReport = id;

    dataStore.showReportWindow = !dataStore.showReportWindow;

    if (dataStore.showReportWindow) {
        document.body.classList.add("comment-window-open", "report");
    } else {
        document.body.classList.remove("comment-window-open", "report");
    }
};

const applyFiltersRequest = async function() {

    return await axios.post(`/api/filtered-answers`, {
        project_slug: dataStore.project.slug,
        item_id: dataStore.currentSlide.id,
        filter: dataStore.selectedFilters
    });
}

/**
 * Description: Applying filters + sets heatmap
 * @return {Void}
 */
 const applyFilters = async function() {

    try {

        const filters = await applyFiltersRequest();

        if (filters) {

            dataStore.collectedAnswers = filters.data;

            if(dataStore.currentSlide.type === 'image' && dataStore.currentSlide.question && dataStore.currentSlide.question.type === 'goodbad' && dataStore.viewActive.heatmap) {
                createHeatMapsImages(dataStore.currentSlide, dataStore.collectedAnswers)
            }

            if(dataStore.currentSlide.question && dataStore.currentSlide.question.type === 'scale') {
                eventRerenderChart(true)
            }

            return filters.data;
        }

        return [];

    } catch (error) {
        console.error(error);
        return [];
    }
};

const checkElement = async function(selector, time) {
    while ( document.querySelector(selector) === null) {
        await new Promise( resolve => requestAnimationFrame(resolve) )
    }
    return document.querySelector(selector);
};

const eventRerenderChart = function(data = null) {

    var chartRerender = new CustomEvent('chartRerender', {
        bubbles: true,
        detail: data
    });

    document.dispatchEvent(chartRerender);
};

const toggleView = function(predefinedValue, ref) {

    dataStore.activeViewIndex++;

    if (dataStore.activeViewIndex > Object.size(dataStore.viewActive) - 1) {
        dataStore.activeViewIndex = 0;
    }

    let currentKey = getCurrentKey();
    
    if( currentKey !== 'normal' ) {
        dataStore.showOnMapPopup = false
        dataStore.showOnMapPopupMarker = null;
    }

    if (predefinedValue) {

        Object.keys(dataStore.viewActive).forEach((key, value) => {
            if (key === predefinedValue) {
                return (dataStore.viewActive[key] = true);
            } else {
                return (dataStore.viewActive[key] = false);
            }
        });
    } else {

        Object.keys(dataStore.viewActive).forEach((key, value) => {
            if (key !== currentKey) {
                return (dataStore.viewActive[key] = false);
            } else {
                return (dataStore.viewActive[key] = true);
            }
        });
    }

    if ( dataStore.viewActive.heatmap && dataStore.currentSlide.type === "image" ) {
        createHeatMapsImages(dataStore.currentSlide, dataStore.collectedAnswers);
    }

    if(dataStore.currentSlide.type === 'image' && dataStore.viewActive.normal) {

        checkElement('.slider-for .slick-current.slick-active .image-type .image-type-slide')
        .then((selector) => repositionImage() )

    }
};

const showTerms = function() {
    dataStore.termsVisable = !dataStore.termsVisable;
};

const getCurrentKey = function() {
    return Object.keys(dataStore.viewActive)[dataStore.activeViewIndex];
};

const goToFirst = function() {
    dataStore.slickNavigation.goTo(0);
};

// exampel http://placetoplan.loc/slite/se-synpunkter/synpunkt/ecce08305a1f43d49ad75074326c3c63
const getSearchParameters = function(project) {

    let path = window.location.pathname;

    const language = {
        en : '/comment/',
        sv : '/synpunkt/',
        fr : '/comment/',
        de : '/comment/',
    }

    const typeUrl = language[project.language.code]

    if( ! path.includes(typeUrl)) return null;

    let values = path.split(typeUrl);

    if(values.length && values.length > 1) {

        let last = values[values.length - 1]

        let obj = {
            'deeplink' : last
        }

        if(last.includes('/')) {
            let parts = last.split("/");

            obj = {
                'deeplink' : parts[0],
                'id' : parts[1],
            }
        }

        return obj;
    }

    return null;
};

const toggleSettingsMenu = function() {

    dataStore.showOptionMenu = !dataStore.showOptionMenu;

    if (dataStore.showOptionMenu) {
        document.body.classList.add("settings-menu-open");
    } else {
        document.body.classList.remove("settings-menu-open");
    }
};

const filtredOptions = function(values, slide) {

    if (values === null || values === "null") return;

    if (slide.question && slide.question.options) {

        let options = slide.question.options.map(option => {

            return {
                id: option.id,
                val: option.value,
                type: option.type
            };

        });

        if(typeof values === 'string') {
            values = JSON.parse(values)
        }

        return options.filter(select => {

            if (values.includes(select.id)) {
                return select.val;
            }
        });

    }
};

const getFileInfo = function(filename) {

    const split = filename.length ? filename.split('.') : ''

    return {
        name: split.length ? split[0] : '',
        ext: split.length ? split[1] : ''
    };
};

const goToNextSlide = function() {

    let totalInIndex = dataStore.totalSlideCount - 1;

    if(dataStore.currentSlideNumber < totalInIndex){
        dataStore.slickNavigation.goTo(dataStore.currentSlideNumber + 1);
    } else {
        dataStore.showLastPartForm = true;
    }

};


const removeTabindex = function(discardSelector = false, className = 'allowtab') {

    const notAllowed = document.querySelectorAll('button, input, textarea, a, [aria-label="Map"], select, [aria-label="Keyboard shortcuts"], body');

    // does not have class which are in allowed classes
    notAllowed.forEach( el =>  {

        if( ! el.hasClass(className) || discardSelector ) {
            el.setAttribute('tabindex', '-1')
        }

    } )

};

const clickableTabElement = function() {

    document.addEventListener('keydown', (event) => {

        if (event.key === "Enter" && event.target.hasClass('allowtab') ) {
            event.target.click()
        }

    });

    // debug current tabed element

    // document.onkeyup = function (event) {
    //     if(event.keyCode == '9'){
    //         console.log('e',event)
    //         console.log('target', event.target)

    //     }
    // };
};

export {
    markerObject,
    hideHint,
    addAnswer,
    setFormPopUpReady,
    toggleOpinionForm,
    getItem,
    removeMarkerIfEmpty,
    dontAllowDropdownOptions,
    allowedLabelsProject,
    updateAnswer,
    removeMarker,
    showReportArea,
    applyFilters,
    applyFiltersRequest,
    toggleView,
    showTerms,
    getCurrentKey,
    goToFirst,
    getSearchParameters,
    toggleSettingsMenu,
    filtredOptions,
    getFileInfo,
    resetCurrentOpinion,
    eventRerenderChart,
    goToNextSlide,
    clickableTabElement,
    removeTabindex,
    clickOutside
};
